import assessmentIcon from "resources/images/assessment-icon.png";
import videoIcon from "resources/images/video-assessment-icon.png";
import liveInterviewIcon from "resources/images/live-interview-icon.png";

/* -------------------------------- Constants -------------------------------- */
export const traitAbbrevToTestFieldObj = {
  10: {
    raw: "rawScore",
    percentile: "percentile",
    verbal: "verbalPercentile",
    math: "mathPercentile",
    spatial: "spatialPercentile",
  },
  12: {
    raw: "rawScore",
    percentile: "percentile",
    math: "mathCorrect",
    verbal: "verbalCorrect",
  },
  13: {
    AGREE: "agreeableness",
    CONSC: "conscientiousness",
    EXT: "extraversion",
    OPEN: "openness",
    STAB: "stressTolerance",
  },
  14: {
    percentile: "overallPercentile",
    ATT: "attention",
    MEM: "memory",
    REA: "reasoning",
    VIG: "vigilance",
    FIL: "filtering",
    VWM: "verbalWorkingMemory",
    SWM: "spatialWorkingMemory",
    VIS: "visualization",
    LOG: "logic",
    IO: "informationOrdering",
    PRT: "perceptualReaction",
    DA: "dividedAttention",
  },
  15: {
    raw: "rawScore",
    SAL: "SAL_adjPercentile",
    CC: "CC_adjPercentile",
    CLS: "CLS_adjPercentile",
    ACH: "ACH_adjPercentile",
    MOT: "MOT_adjPercentile",
    CMP: "CMP_adjPercentile",
    GO: "GO_adjPercentile",
    PLN: "PLN_adjPercentile",
    INI: "INI_adjPercentile",
    TMP: "TMP_adjPercentile",
    MGT: "MGT_adjPercentile",
    AST: "AST_adjPercentile",
    PDL: "PDL_adjPercentile",
    EXT: "EXT_adjPercentile",
    COP: "COP_adjPercentile",
    RLX: "RLX_adjPercentile",
    PAT: "PAT_adjPercentile",
    SCN: "SCN_adjPercentile",
  },
  16: { raw: "rawScore", percentile: "percentile" },
  17: { raw: "rawScore", percentile: "percentile" },
  18: { raw: "wpm" },
  19: { raw: "rawScore", percentile: "percentile" },
  20: { raw: "rawScore", percentile: "percentile" },
  21: { raw: "rawScore", percentile: "percentile" },
  22: { raw: "rawScore", percentile: "percentile" },
  23: {
    percentile: "overallPercentile",
    DA: "dividedAttention",
    VIG: "vigilance",
    FIL: "filtering",
    PRT: "perceptualReaction",
  },
  24: {
    raw: "rawScore",
    SAL: "SAL_adjPercentile",
    CC: "CC_adjPercentile",
    CLS: "CLS_adjPercentile",
    ACH: "ACH_adjPercentile",
    MOT: "MOT_adjPercentile",
    CMP: "CMP_adjPercentile",
    GO: "GO_adjPercentile",
    PLN: "PLN_adjPercentile",
    INI: "INI_adjPercentile",
    TMP: "TMP_adjPercentile",
    MGT: "MGT_adjPercentile",
    AST: "AST_adjPercentile",
    PDL: "PDL_adjPercentile",
    EXT: "EXT_adjPercentile",
    COP: "COP_adjPercentile",
    RLX: "RLX_adjPercentile",
    PAT: "PAT_adjPercentile",
    SCN: "SCN_adjPercentile",
  },
  29: {
    ACH: "EPPAchievement",
    MOT: "EPPMotivation",
    CMP: "EPPCompetitiveness",
    MGT: "EPPManagerial",
    AST: "EPPAssertiveness",
    EXT: "EPPExtroversion",
    COP: "EPPCooperativeness",
    PAT: "EPPPatience",
    SCN: "EPPSelfConfidence",
    CON: "EPPConscientiousness",
  },
  30: { raw: "rawScore", ranking: "CLIKRanking" },
  31: {
    raw: "rawScore",
    CON: "CON_percentile",
    PER: "PER_percentile",
    HON: "HON_percentile",
    THEFT: "THEFT_percentile",
  },
  32: { raw: "rawScore", percentile: "percentile" },
  33: { raw: "rawScore", percentile: "percentile" },
  34: {
    ACH: "EPPAchievement",
    MOT: "EPPMotivation",
    CMP: "EPPCompetitiveness",
    MGT: "EPPManagerial",
    AST: "EPPAssertiveness",
    EXT: "EPPExtroversion",
    COP: "EPPCooperativeness",
    PAT: "EPPPatience",
    SCN: "EPPSelfConfidence",
    CON: "EPPConscientiousness",
    OPEN: "EPPOpenness",
    STAB: "EPPStressTolerance",
    Manager: "EPPJobMatch:Manager",
    AccountingFinance: "EPPJobMatch:Accounting/Finance",
    Administrative_Assistant: "EPPJobMatch:AdministrativeAsst",
    Analyst: "EPPJobMatch:Analyst",
    Bank_Teller: "EPPJobMatch:BankTeller",
    Collections: "EPPJobMatch:Collections",
    Customer_Service: "EPPJobMatch:CustomerService",
    Front_DeskReception: "EPPJobMatch:FrontDesk/Reception",
    Medical_Assistant: "EPPJobMatch:MedicalAssistant",
    ProductionManufacturing: "EPPJobMatch:Production/Manufacturing",
    ProgrammerDeveloper: "EPPJobMatch:Programmer/Developer",
    Sales: "EPPJobMatch:Sales",
  },
  35: { raw: "rawScore", percentile: "percentile" },
  36: { raw: "rawScore", percentile: "percentile" },
  37: {
    raw: "rawScore",
    percentile: "percentile",
    logic: "logicPercentile",
    math: "mathPercentile",
    detail: "detailPercentile",
    spatial: "spatialPercentile",
  },
  38: { raw: "rawScore", percentile: "percentile" },
  39: { raw: "rawScore", percentile: "percentile" },
  40: { raw: "rawScore", percentile: "percentile" },
  41: { raw: "rawScore", percentile: "percentile" },
  42: {
    percentile: "percentile",
    detail: "detailPercentile",
    verbal: "verbalPercentile",
    math: "mathPercentile",
  },
  43: { raw: "rawScore", percentile: "percentile" },
  44: {
    raw: "rawScore",
    percentile: "percentile",
    perceiving: "perceivingPercentile",
    understand: "understandPercentile",
  },
  45: {
    raw: "rawScore",
    percentile: "percentile",
    problemSolving: "problemSolvingPercentile",
    numericalReasoning: "numericalReasoningPercentile",
    verbalKnowledge: "verbalKnowledgePercentile",
  },
  46: {
    raw: "rawScore",
    percentile: "percentile",
    safety: "safetyPercentileScore",
    risk: "riskPercentileScore",
    stress: "stressPercentileScore",
    drug: "drugPercentileScore",
    violence: "violencePercentileScore",
    ENH: "validityENHPercentile",
    INC: "validityINCScore",
  },
  48: { raw: "rawScore", percentile: "percentile" },
  49: { raw: "rawScore", ranking: "CLIKRanking" },
  50: {
    raw: "rawScore",
    percentile: "percentile",
  },
  51: {
    raw: "rawScore",
    percentile: "percentile",
    perceiving: "perceivingPercentile",
    understand: "understandPercentile",
    managing: "managingPercentile",
  },
  52: {
    raw: "rawScore",
    percentile: "percentile",
    problemSolving: "problemSolvingPercentile",
    numericalReasoning: "numericalReasoningPercentile",
  },
  53: { score: "score", proficiency: "proficiency" },
  54: { score: "score", proficiency: "proficiency" },
  55: { score: "score", proficiency: "proficiency" },
  57: {
    score: "stwenty",
    proficiency: "proficiency",
    readingScore: "readingScore",
    readingProficiency: "readingProficiency",
    readingCEFR: "readingCEFR",
    listeningScore: "listeningScore",
    listeningProficiency: "listeningProficiency",
    listeningCEFR: "listeningCEFR",
    writingScore: "writingScore",
    writingProficiency: "writingProficiency",
    writingCEFR: "writingCEFR",
  },
  59: {
    percentile: "percentile",
  },
  // LAST LINE - DO NOT MOVE THIS COMMENT traitAbbrevToTestFieldObj
  TM: { raw: "rawScore" },
};

export const traitIdToTest = {
  1: { traitAbbrev: "raw", testId: 10 },
  2: { traitAbbrev: "percentile", testId: 10 },
  3: { traitAbbrev: "verbal", testId: 10 },
  4: { traitAbbrev: "math", testId: 10 },
  5: { traitAbbrev: "spatial", testId: 10 },
  6: { traitAbbrev: "raw", testId: 12 },
  7: { traitAbbrev: "percentile", testId: 12 },
  8: { traitAbbrev: "math", testId: 12 },
  9: { traitAbbrev: "verbal", testId: 12 },
  10: { traitAbbrev: "AGREE", testId: 13 },
  11: { traitAbbrev: "CONSC", testId: 13 },
  12: { traitAbbrev: "EXTRA", testId: 13 },
  13: { traitAbbrev: "OPEN", testId: 13 },
  14: { traitAbbrev: "STAB", testId: 13 },
  15: { traitAbbrev: "percentile", testId: 14 },
  16: { traitAbbrev: "ATT", testId: 14 },
  17: { traitAbbrev: "MEM", testId: 14 },
  18: { traitAbbrev: "REA", testId: 14 },
  19: { traitAbbrev: "DA", testId: 14 },
  20: { traitAbbrev: "VIG", testId: 14 },
  21: { traitAbbrev: "FIL", testId: 14 },
  22: { traitAbbrev: "VWM", testId: 14 },
  23: { traitAbbrev: "SWM", testId: 14 },
  24: { traitAbbrev: "VIS", testId: 14 },
  25: { traitAbbrev: "LOG", testId: 14 },
  26: { traitAbbrev: "IO", testId: 14 },
  27: { traitAbbrev: "PRT", testId: 14 },
  28: { traitAbbrev: "raw", testId: 15 },
  29: { traitAbbrev: "SAL", testId: 15 },
  30: { traitAbbrev: "CC", testId: 15 },
  31: { traitAbbrev: "CLS", testId: 15 },
  32: { traitAbbrev: "ACH", testId: 15 },
  33: { traitAbbrev: "MOT", testId: 15 },
  34: { traitAbbrev: "CMP", testId: 15 },
  35: { traitAbbrev: "GO", testId: 15 },
  36: { traitAbbrev: "PLN", testId: 15 },
  37: { traitAbbrev: "INI", testId: 15 },
  38: { traitAbbrev: "TMP", testId: 15 },
  39: { traitAbbrev: "MGT", testId: 15 },
  40: { traitAbbrev: "AST", testId: 15 },
  41: { traitAbbrev: "PDL", testId: 15 },
  42: { traitAbbrev: "EXT", testId: 15 },
  43: { traitAbbrev: "COP", testId: 15 },
  44: { traitAbbrev: "RLX", testId: 15 },
  45: { traitAbbrev: "PAT", testId: 15 },
  46: { traitAbbrev: "SCN", testId: 15 },
  47: { traitAbbrev: "raw", testId: 16 },
  48: { traitAbbrev: "percentile", testId: 16 },
  49: { traitAbbrev: "raw", testId: 17 },
  50: { traitAbbrev: "percentile", testId: 17 },
  51: { traitAbbrev: "raw", testId: 18 },
  53: { traitAbbrev: "raw", testId: 21 },
  54: { traitAbbrev: "percentile", testId: 21 },
  55: { traitAbbrev: "raw", testId: 22 },
  56: { traitAbbrev: "percentile", testId: 22 },
  57: { traitAbbrev: "percentile", testId: 23 },
  58: { traitAbbrev: "DA", testId: 23 },
  59: { traitAbbrev: "VIG", testId: 23 },
  60: { traitAbbrev: "FIL", testId: 23 },
  61: { traitAbbrev: "PRT", testId: 23 },
  62: { traitAbbrev: "raw", testId: 24 },
  63: { traitAbbrev: "SAL", testId: 24 },
  64: { traitAbbrev: "CC", testId: 24 },
  65: { traitAbbrev: "CLS", testId: 24 },
  66: { traitAbbrev: "ACH", testId: 24 },
  67: { traitAbbrev: "MOT", testId: 24 },
  68: { traitAbbrev: "CMP", testId: 24 },
  69: { traitAbbrev: "GO", testId: 24 },
  70: { traitAbbrev: "PLN", testId: 24 },
  71: { traitAbbrev: "INI", testId: 24 },
  72: { traitAbbrev: "TMP", testId: 24 },
  73: { traitAbbrev: "MGT", testId: 24 },
  74: { traitAbbrev: "AST", testId: 24 },
  75: { traitAbbrev: "PDL", testId: 24 },
  76: { traitAbbrev: "EXT", testId: 24 },
  77: { traitAbbrev: "COP", testId: 24 },
  78: { traitAbbrev: "RLX", testId: 24 },
  79: { traitAbbrev: "PAT", testId: 24 },
  80: { traitAbbrev: "SCN", testId: 24 },
  81: { traitAbbrev: "ACH", testId: 29 },
  82: { traitAbbrev: "MOT", testId: 29 },
  83: { traitAbbrev: "CMP", testId: 29 },
  84: { traitAbbrev: "MGT", testId: 29 },
  85: { traitAbbrev: "AST", testId: 29 },
  86: { traitAbbrev: "EXT", testId: 29 },
  87: { traitAbbrev: "COP", testId: 29 },
  88: { traitAbbrev: "PAT", testId: 29 },
  89: { traitAbbrev: "SCN", testId: 29 },
  90: { traitAbbrev: "CON", testId: 29 },
  91: { traitAbbrev: "raw", testId: 30 },
  92: { traitAbbrev: "ranking", testId: 30 },
  93: { traitAbbrev: "raw", testId: 31 },
  94: { traitAbbrev: "CON", testId: 31 },
  95: { traitAbbrev: "PER", testId: 31 },
  96: { traitAbbrev: "HON", testId: 31 },
  97: { traitAbbrev: "THEFT", testId: 31 },
  98: { traitAbbrev: "raw", testId: 32 },
  99: { traitAbbrev: "percentile", testId: 32 },
  100: { traitAbbrev: "raw", testId: 33 },
  101: { traitAbbrev: "percentile", testId: 33 },
  102: { traitAbbrev: "ACH", testId: 34 },
  103: { traitAbbrev: "MOT", testId: 34 },
  104: { traitAbbrev: "CMP", testId: 34 },
  105: { traitAbbrev: "MGT", testId: 34 },
  106: { traitAbbrev: "AST", testId: 34 },
  107: { traitAbbrev: "EXT", testId: 34 },
  108: { traitAbbrev: "COP", testId: 34 },
  109: { traitAbbrev: "PAT", testId: 34 },
  110: { traitAbbrev: "SCN", testId: 34 },
  111: { traitAbbrev: "CON", testId: 34 },
  112: { traitAbbrev: "OPEN", testId: 34 },
  113: { traitAbbrev: "STAB", testId: 34 },
  114: { traitAbbrev: "Manager", testId: 34 },
  115: { traitAbbrev: "AccountingFinance", testId: 34 },
  116: { traitAbbrev: "Administrative_Assistant", testId: 34 },
  117: { traitAbbrev: "Analyst", testId: 34 },
  118: { traitAbbrev: "Bank_Teller", testId: 34 },
  119: { traitAbbrev: "Collections", testId: 34 },
  120: { traitAbbrev: "Customer_Service", testId: 34 },
  121: { traitAbbrev: "Front_DeskReception", testId: 34 },
  122: { traitAbbrev: "Medical_Assistant", testId: 34 },
  123: { traitAbbrev: "ProductionManufacturing", testId: 34 },
  124: { traitAbbrev: "ProgrammerDeveloper", testId: 34 },
  125: { traitAbbrev: "Sales", testId: 34 },
  126: { traitAbbrev: "raw", testId: 35 },
  127: { traitAbbrev: "percentile", testId: 35 },
  128: { traitAbbrev: "raw", testId: 36 },
  129: { traitAbbrev: "percentile", testId: 36 },
  130: { traitAbbrev: "raw", testId: 37 },
  131: { traitAbbrev: "percentile", testId: 37 },
  132: { traitAbbrev: "logic", testId: 37 },
  133: { traitAbbrev: "math", testId: 37 },
  134: { traitAbbrev: "detail", testId: 37 },
  135: { traitAbbrev: "spatial", testId: 37 },
  136: { traitAbbrev: "raw", testId: 38 },
  137: { traitAbbrev: "percentile", testId: 38 },
  138: { traitAbbrev: "raw", testId: 39 },
  139: { traitAbbrev: "percentile", testId: 39 },
  140: { traitAbbrev: "raw", testId: 40 },
  141: { traitAbbrev: "percentile", testId: 40 },
  142: { traitAbbrev: "raw", testId: 41 },
  143: { traitAbbrev: "percentile", testId: 41 },
  144: { traitAbbrev: "percentile", testId: 42 },
  145: { traitAbbrev: "detail", testId: 42 },
  146: { traitAbbrev: "verbal", testId: 42 },
  147: { traitAbbrev: "math", testId: 42 },
  148: { traitAbbrev: "raw", testId: 43 },
  149: { traitAbbrev: "percentile", testId: 43 },
  150: { traitAbbrev: "percentile", testId: 44 },
  151: { traitAbbrev: "perceivingPercentile", testId: 44 },
  152: { traitAbbrev: "understandPercentile", testId: 44 },
  153: { traitAbbrev: "percentile", testId: 45 },
  154: { traitAbbrev: "problemSolving", testId: 45 },
  155: { traitAbbrev: "numericalReasoning", testId: 45 },
  156: { traitAbbrev: "verbalKnowledge", testId: 45 },
  157: { traitAbbrev: "percentile", testId: 46 },
  158: { traitAbbrev: "safety", testId: 46 },
  159: { traitAbbrev: "risk", testId: 46 },
  160: { traitAbbrev: "stress", testId: 46 },
  161: { traitAbbrev: "drug", testId: 46 },
  162: { traitAbbrev: "violence", testId: 46 },
  163: { traitAbbrev: "ENH", testId: 46 },
  164: { traitAbbrev: "INC", testId: 46 },
  175: { traitAbbrev: "raw", testId: 49 },
  176: { traitAbbrev: "ranking", testId: 49 },
  166: { traitAbbrev: "percentile", testId: 50 },
  167: { traitAbbrev: "raw", testId: 50 },
  168: { traitAbbrev: "percentile", testId: 51 },
  169: { traitAbbrev: "perceivingPercentile", testId: 51 },
  170: { traitAbbrev: "understandPercentile", testId: 51 },
  171: { traitAbbrev: "managingPercentile", testId: 51 },
  172: { traitAbbrev: "percentile", testId: 52 },
  173: { traitAbbrev: "problemSolving", testId: 52 },
  174: { traitAbbrev: "numericalReasoning", testId: 52 },
  177: { traitAbbrev: "percentile", testId: 48 },
  178: { traitAbbrev: "score", testId: 53 },
  179: { traitAbbrev: "proficiency", testId: 53 },
  180: { traitAbbrev: "score", testId: 54 },
  181: { traitAbbrev: "proficiency", testId: 54 },
  182: { traitAbbrev: "score", testId: 55 },
  183: { traitAbbrev: "proficiency", testId: 55 },
  184: { traitAbbrev: "score", testId: 57 },
  185: { traitAbbrev: "proficiency", testId: 57 },
  186: { traitAbbrev: "readingScore", testId: 57 },
  187: { traitAbbrev: "readingProficiency", testId: 57 },
  188: { traitAbbrev: "readingCEFR", testId: 57 },
  189: { traitAbbrev: "listeningScore", testId: 57 },
  190: { traitAbbrev: "listeningProficiency", testId: 57 },
  191: { traitAbbrev: "listeningCEFR", testId: 57 },
  192: { traitAbbrev: "writingScore", testId: 57 },
  193: { traitAbbrev: "writingProficiency", testId: 57 },
  194: { traitAbbrev: "writingCEFR", testId: 57 },
  195: { traitAbbrev: "percentile", testId: 59 },
  // LAST LINE - DO NOT MOVE THIS COMMENT traitIdToTest
};

export const proficiencyToScore = {
  "Not Proficient": 1,
  Proficient: 2,
  "Highly Proficient": 3,
};

export const clptSubTestIds = [
  "190",
  "192",
  "193",
  "194",
  "195",
  "196",
  "197",
  "198",
  "199",
  "200",
  "201",
  "202",
  "203",
];

export const clptExpressSubTestIds = [
  "191",
  "204",
  "205",
  "206",
  "207",
  "208",
  "209",
  "210",
  "211",
  "212",
  "213",
  "214",
  "215",
];
export const ctrsExpressSubtestIds = ["240"];

// an array of tests of which their subTests should be used for certain circumstances
export const testsRequiringSubTestIds = {
  53: ["179", "180"],
  57: [...clptSubTestIds, ...clptExpressSubTestIds],
  59: [...ctrsExpressSubtestIds],
};

// test ids stored in PM-requested order. essentially alpha order
// some tests have to be placed together despite the alpha order, eg `Microsoft Word 2016` and `Word 365`
export const testsIdObj = {
  aptitudeTests: [23, 10, 43, 59, 45, 42, 14, 52, 37, 16],
  personalityTests: [13, 15, 34, 48, 24, 50],
  emotionalTests: [44, 51],
  skillsTests: [30, 49, 12, 57, 53, 39, 55, 41, 18, 17, 54, 40],
  riskTests: [31, 46],
};

// AU test ids stored in PM-requested order. essentially alpha order
// some tests have to be placed together despite the alpha order, eg `Microsoft Word 2016` and `Word 365`
export const testsAUIdObj = {
  aptitudeTests: [23, 10, 43, 59, 45, 42, 52, 37],
  personalityTests: [34, 48, 50],
  emotionalTests: [44, 51],
  skillsTests: [30, 49, 12, 57, 53, 39, 55, 41, 18, 17, 54, 40],
  riskTests: [31, 46],
};

export const screenReaderCompatibleTests = [57, 59];

export const ctrseTranslatedSubTestIds = ["241", "242", "243"];

// VI merchandizing utm params
export const viMerchandizingUtmParams = {
  manageVITemplates: {
    content: "manage-vi-template",
    campaign: "vi-merch1",
    source: "platform",
    medium: "lock",
  },
  createJobVideoInterview: {
    content: "create-job",
    campaign: "vi-merch1",
    source: "platform",
    medium: "lock",
  },
  createJobLiveInterview: {
    content: "create-job",
    campaign: "si-merch1",
    source: "platform",
    medium: "lock",
  },
  jobSettings: {
    content: "job-settings-talent-signal",
    campaign: "vi-merch1",
    source: "platform",
    medium: "learn-more",
  },
  companyPreferencesTalentSignal: {
    content: "company-preferences-talent-signal",
    campaign: "vi-merch1",
    source: "platform",
    medium: "learn-more",
  },
  // Dashboard
  dashboardLearnMore: {
    content: "dashboard",
    campaign: "vi-merch1",
    source: "platform",
    medium: "banner-learn-more",
  },
  dashboardDirect: {
    content: "dashboard",
    campaign: "vi-merch1",
    source: "platform",
    medium: "banner-direct",
  },
  tssFreeTrialBanner: {
    content: "dashboard",
    campaign: "tss-welcome-banner",
    source: "platform",
    medium: "banner-schedule-call",
  },
  // Results page
  resultsLearnMore: {
    content: "results",
    campaign: "vi-merch1",
    source: "platform",
    medium: "banner-learn-more",
  },
  resultsDirect: {
    content: "results",
    campaign: "vi-merch1",
    source: "platform",
    medium: "banner-direct",
  }, // DSR
  dsrLearnMore: {
    content: "dsr",
    campaign: "vi-merch1",
    source: "platform",
    medium: "banner-learn-more",
  },
  dsrDirect: {
    content: "dsr",
    campaign: "vi-merch1",
    source: "platform",
    medium: "banner-direct",
  },
  analyticsLearnMore: {
    content: "analytics",
    campaign: "vi-merch1",
    source: "platform",
    medium: "block-learn-more",
  },
  analyticsDirect: {
    content: "analytics",
    campaign: "vi-merch1",
    source: "platform",
    medium: "block-direct",
  },
};

export const siMerchandizingUtmParams = {
  candidateProfileLearnMore: {
    content: "candidate-profile",
    campaign: "si-merch1",
    source: "platform",
    medium: "banner-learn-more",
  },
};

export const mgMerchandizingUtmParams = {
  mgMerchandizingDiscover: {
    content: "Manager_guide_Adopt_Develop_V1",
    campaign: "Develop",
    source: "platform",
    medium: "",
  },
};

export const freeTrialSelfServicePurchaseUtmParams = {
  subscriptionBanner: {
    content: "free_trial_se",
    campaign: "global_free_tree_banner",
    source: "platform",
    medium: "banner-schedule-demo",
  },
  checkoutError: {
    content: "checkout-error",
    campaign: "updated-checkout-ui",
    source: "platform",
    medium: "checkout-error-schedule",
  },
};

export const vistaPortcoPartnerIds = [
  15, 39, 40, 42, 44, 45, 46, 51, 52, 53, 54, 55, 56, 57, 58, 86, 87, 88, 89,
  90,
];

const SAP_CSAP_DROPDOWNS_INFO = [
  {
    "By Recommendation": {
      title: "N/A",
      defaultValue: {
        min: 1,
        max: 3,
      },
      values: null,
    },
    "By Trait Percentile": {
      title: "Traits",
      defaultValue: null,
      values: {
        Achievement: {
          min: 0,
          max: 100,
        },
        Assertiveness: {
          min: 0,
          max: 100,
        },
        Competitiveness: {
          min: 0,
          max: 100,
        },
        Cooperativeness: {
          min: 0,
          max: 100,
        },
        Extroversion: {
          min: 0,
          max: 100,
        },
        "Goal Orientation": {
          min: 0,
          max: 100,
        },
        "Initiative - Cold Calling": {
          min: 0,
          max: 100,
        },
        "Initiative - General": {
          min: 0,
          max: 100,
        },
        Managerial: {
          min: 0,
          max: 100,
        },
        Motivation: {
          min: 0,
          max: 100,
        },
        Patience: {
          min: 0,
          max: 100,
        },
        "Personal Diplomacy": {
          min: 0,
          max: 100,
        },
        Planning: {
          min: 0,
          max: 100,
        },
        "Relaxed Style": {
          min: 0,
          max: 100,
        },
        "Sales Closing": {
          min: 0,
          max: 100,
        },
        "Sales Disposition": {
          min: 0,
          max: 100,
        },
        "Self-Confidence": {
          min: 0,
          max: 100,
        },
        "Team Player": {
          min: 0,
          max: 100,
        },
      },
    },
  },
  null, // no national norms data for salesAP / CSAP
  {
    raw: { first: "By Recommendation", second: null },
    SAL: { first: "By Trait Percentile", second: "Sales Disposition" },
    CC: {
      first: "By Trait Percentile",
      second: "Initiative - Cold Calling",
    },
    CLS: { first: "By Trait Percentile", second: "Sales Closing" },
    ACH: { first: "By Trait Percentile", second: "Achievement" },
    MOT: { first: "By Trait Percentile", second: "Motivation" },
    CMP: { first: "By Trait Percentile", second: "Competitiveness" },
    GO: { first: "By Trait Percentile", second: "Goal Orientation" },
    PLN: { first: "By Trait Percentile", second: "Planning" },
    INI: { first: "By Trait Percentile", second: "Initiative - General" },
    TMP: { first: "By Trait Percentile", second: "Team Player" },
    MGT: { first: "By Trait Percentile", second: "Managerial" },
    AST: { first: "By Trait Percentile", second: "Assertiveness" },
    PDL: { first: "By Trait Percentile", second: "Personal Diplomacy" },
    EXT: { first: "By Trait Percentile", second: "Extroversion" },
    COP: { first: "By Trait Percentile", second: "Cooperativeness" },
    RLX: { first: "By Trait Percentile", second: "Relaxed Style" },
    PAT: { first: "By Trait Percentile", second: "Patience" },
    SCN: { first: "By Trait Percentile", second: "Self-Confidence" },
  },
];

const COGNIFY_UCOGNIFY_OVERALL_PERCENTILE_INFO = {
  title: "Score Range By Position",
  defaultValue: {
    min: 0,
    max: 100,
  },
  values: {
    Accounting: { min: 30, max: 100 },
    Analyst: { min: 31, max: 100 },
    "Architecture and Drafting": { min: 28, max: 100 },
    "Art and Design": { min: 25, max: 100 },
    Aviation: { min: 23, max: 100 },
    "Business Operations Specialist": { min: 29, max: 100 },
    Cashier: { min: 21, max: 100 },
    Collections: { min: 21, max: 100 },
    "Counselling and Social Work": { min: 28, max: 100 },
    "Customer Service Representative": { min: 20, max: 100 },
    "Data Analytics and Statistics": { min: 40, max: 100 },
    Dispatcher: { min: 20, max: 100 },
    Driver: { min: 19, max: 100 },
    Education: { min: 28, max: 100 },
    "Emergency and Protective Services": { min: 23, max: 100 },
    Engineering: { min: 34, max: 100 },
    "Farming, Agriculture and Forestry": { min: 18, max: 100 },
    "Finance Manager": { min: 32, max: 100 },
    "Financial Services": { min: 33, max: 100 },
    "Food Preparation and Service": { min: 19, max: 100 },
    "Freight and Distribution": { min: 18, max: 100 },
    "Front Line Supervision": { min: 23, max: 100 },
    "Grounds and Cleaning": { min: 17, max: 100 },
    "HR Manager": { min: 29, max: 100 },
    "Human Resources": { min: 25, max: 100 },
    "IT and Computing Systems": { min: 28, max: 100 },
    "IT Manager": { min: 27, max: 100 },
    "IT Support": { min: 24, max: 100 },
    "Journalism and Communications": { min: 18, max: 100 },
    Legal: { min: 28, max: 100 },
    "Machinist / Manufacturing Technician": { min: 21, max: 100 },
    Management: { min: 27, max: 100 },
    "Marketing and Product": { min: 30, max: 100 },
    "Media Production": { min: 26, max: 100 },
    "Medical Assistance": { min: 24, max: 100 },
    "Medicine and Healthcare": { min: 26, max: 100 },
    "Mining, Oil, and Gas Worker": { min: 19, max: 100 },
    Nursing: { min: 25, max: 100 },
    "Office and Administrative Support": { min: 26, max: 100 },
    "Paralegal and Legal Support": { min: 20, max: 100 },
    "Personal Care and Services": { min: 18, max: 100 },
    "Plant Operator": { min: 23, max: 100 },
    "Production Manager / Supervisor": { min: 25, max: 100 },
    "Production Worker": { min: 19, max: 100 },
    "Project Manager": { min: 28, max: 100 },
    "Retail Sales": { min: 20, max: 100 },
    "Sales / Account Executive": { min: 28, max: 100 },
    "Sales Manager": { min: 31, max: 100 },
    "Sales Representative": { min: 22, max: 100 },
    "Science and Research": { min: 31, max: 100 },
    "Senior and Executive Leadership": { min: 32, max: 100 },
    "Service Technician": { min: 24, max: 100 },
    "Software Development": { min: 29, max: 100 },
    "Store Manager": { min: 23, max: 100 },
    "Trades and Construction": { min: 20, max: 100 },
  },
};
const CTRSE_OVERALL_PERCENTILE_INFO = {
  title: "Score Range By Position",
  defaultValue: {
    min: 0,
    max: 100,
  },
  values: {
    Accounting: { min: 25, max: 99 },
    Analyst: { min: 34, max: 99 },
    "Architecture and Drafting": { min: 25, max: 99 },
    "Art and Design": { min: 21, max: 99 },
    Aviation: { min: 25, max: 99 },
    "Business Operations Specialist": { min: 25, max: 99 },
    "Counselling and Social Work": { min: 25, max: 99 },
    "Customer Service Representative": { min: 14, max: 99 },
    "Customer Service Manager": { min: 21, max: 99 },
    "Data Analytics and Statistics": { min: 43, max: 99 },
    Education: { min: 25, max: 99 },
    "Emergency and Protective Services": { min: 21, max: 99 },
    Engineering: { min: 34, max: 99 },
    "Finance Manager": { min: 34, max: 99 },
    "Financial Services": { min: 25, max: 99 },
    "HR Manager": { min: 29, max: 99 },
    "Human Resources": { min: 25, max: 99 },
    "IT and Computing Systems": { min: 29, max: 99 },
    "IT Manager": { min: 25, max: 99 },
    "IT Support": { min: 25, max: 99 },
    "Journalism and Communications": { min: 25, max: 99 },
    Legal: { min: 43, max: 99 },
    Management: { min: 25, max: 99 },
    "Marketing and Product": { min: 29, max: 99 },
    "Media Production": { min: 25, max: 99 },
    "Medical Assistance": { min: 21, max: 99 },
    "Medicine and Healthcare": { min: 34, max: 99 },
    Nursing: { min: 29, max: 99 },
    "Office and Administrative Support": { min: 21, max: 99 },
    "Paralegal and Legal Support": { min: 21, max: 99 },
    "Plant Operator": { min: 17, max: 99 },
    "Production Manager / Supervisor": { min: 21, max: 99 },
    "Project Manager": { min: 29, max: 99 },
    "Retail Sales": { min: 14, max: 99 },
    "Sales / Account Executive": { min: 21, max: 99 },
    "Sales Manager": { min: 25, max: 99 },
    "Sales Representative": { min: 14, max: 99 },
    "Science and Research": { min: 34, max: 99 },
    "Senior and Executive Leadership": { min: 34, max: 99 },
    "Service Technician": { min: 14, max: 99 },
    "Software Development": { min: 25, max: 99 },
    "Store Manager": { min: 17, max: 99 },
  },
};

// MS365 Tests not included
const getMicrosoftSkillsTestInfo = (testId) => {
  let metrics = null;
  let testAbbrev = "";
  switch (testId) {
    // EXCEL
    case 19:
    case 21:
    case 32:
    case 35:
    case 39:
      testAbbrev = "EXCEL";
      metrics = {
        average: 11.0,
        median: 10.0,
        cutoff: 10.0,
      };
      break;
    // WORD
    case 20:
    case 22:
    case 33:
    case 36:
    case 40:
      testAbbrev = "WORD";
      metrics = {
        average: 13.6,
        median: 14.0,
        cutoff: 13.0,
      };
      break;
    // PPT
    case 38:
    case 41:
      testAbbrev = "PPT";
      metrics = {
        average: 14.5,
        median: 15.0,
        cutoff: 13.0,
      };
      break;
    default:
      return;
  }
  return [
    {
      testAbbrev,
      testType: "Skills",
    },
    {
      "By Raw Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
    },
    metrics,
    {
      raw: { first: "By Raw Score", second: null },
      percentile: { first: "By Overall Percentile", second: null },
    },
  ];
};

export const CUSTOM_FILTER_OPTIONS_LIBRARY = {
  10: [
    {
      testAbbrev: "CCAT",
      testType: "Aptitude",
    },
    {
      "By Raw Score": {
        title: "Score Range By Position",
        defaultValue: {
          min: 0,
          max: 50,
        },
        values: {
          Accounting: { min: 20, max: 50 },
          Analyst: { min: 22, max: 50 },
          "Architecture and Drafting": { min: 20, max: 50 },
          "Art and Design": { min: 19, max: 50 },
          Aviation: { min: 20, max: 50 },
          "Business Operations Specialist": { min: 20, max: 50 },
          Cashier: { min: 16, max: 50 },
          Collections: { min: 19, max: 50 },
          "Counselling and Social Work": { min: 20, max: 50 },
          "Customer Service Representative": { min: 17, max: 50 },
          "Data Analytics and Statistics": { min: 24, max: 50 },
          Dispatcher: { min: 18, max: 50 },
          Driver: { min: 15, max: 50 },
          Education: { min: 20, max: 50 },
          "Emergency and Protective Services": { min: 19, max: 50 },
          Engineering: { min: 22, max: 50 },
          "Farming, Agriculture and Forestry": { min: 18, max: 50 },
          "Finance Manager": { min: 22, max: 50 },
          "Financial Services": { min: 20, max: 50 },
          "Food Preparation and Service": { min: 15, max: 50 },
          "Freight and Distribution": { min: 15, max: 50 },
          "Front Line Supervision": { min: 19, max: 50 },
          "Grounds and Cleaning": { min: 16, max: 50 },
          "HR Manager": { min: 21, max: 50 },
          "Human Resources": { min: 20, max: 50 },
          "IT and Computing Systems": { min: 21, max: 50 },
          "IT Manager": { min: 20, max: 50 },
          "IT Support": { min: 20, max: 50 },
          "Journalism and Communications": { min: 20, max: 50 },
          Legal: { min: 24, max: 50 },
          "Machinist / Manufacturing Technician": { min: 16, max: 50 },
          Management: { min: 20, max: 50 },
          "Marketing and Product": { min: 21, max: 50 },
          "Media Production": { min: 20, max: 50 },
          "Medical Assistance": { min: 19, max: 50 },
          "Medicine and Healthcare": { min: 22, max: 50 },
          "Mining, Oil, and Gas Worker": { min: 16, max: 50 },
          Nursing: { min: 21, max: 50 },
          "Office and Administrative Support": { min: 19, max: 50 },
          "Paralegal and Legal Support": { min: 19, max: 50 },
          "Personal Care and Services": { min: 17, max: 50 },
          "Plant Operator": { min: 18, max: 50 },
          "Production Manager / Supervisor": { min: 19, max: 50 },
          "Production Worker": { min: 14, max: 50 },
          "Project Manager": { min: 21, max: 50 },
          "Retail Sales": { min: 17, max: 50 },
          "Sales / Account Executive": { min: 19, max: 50 },
          "Sales Manager": { min: 20, max: 50 },
          "Sales Representative": { min: 17, max: 50 },
          "Science and Research": { min: 22, max: 50 },
          "Senior and Executive Leadership": { min: 22, max: 50 },
          "Service Technician": { min: 17, max: 50 },
          "Software Development": { min: 20, max: 50 },
          "Store Manager": { min: 18, max: 50 },
          "Trades and Construction": { min: 18, max: 50 },
        },
      },
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
      "By Trait Percentile": {
        title: "Trait",
        defaultValue: null,
        values: {
          "Math & Logic": {
            min: 0,
            max: 100,
          },
          "Spatial Reasoning": {
            min: 0,
            max: 100,
          },
          "Verbal Ability": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    {
      average: 24.2,
      median: 24.0,
      cutoff: 21.0,
    },
    {
      raw: { first: "By Raw Score", second: null },
      percentile: { first: "By Overall Percentile", second: null },
      verbal: { first: "By Trait Percentile", second: "Verbal Ability" },
      math: { first: "By Trait Percentile", second: "Math & Logic" },
      spatial: {
        first: "By Trait Percentile",
        second: "Spatial Reasoning",
      },
    },
  ],
  12: [
    {
      testAbbrev: "CBST",
      testType: "Skills",
    },
    {
      "By Raw Score": {
        title: "Score Range by Position",
        defaultValue: {
          min: 0,
          max: 40,
        },
        values: {
          Accounting: { min: 30, max: 40 },
          Analyst: { min: 31, max: 40 },
          "Architecture and Drafting": { min: 30, max: 40 },
          "Art and Design": { min: 28, max: 40 },
          Aviation: { min: 30, max: 40 },
          "Business Operations Specialist": { min: 30, max: 40 },
          Cashier: { min: 27, max: 40 },
          Collections: { min: 31, max: 40 },
          "Counselling and Social Work": { min: 29, max: 40 },
          "Customer Service Representative": { min: 28, max: 40 },
          "Data Analytics and Statistics": { min: 32, max: 40 },
          Dispatcher: { min: 29, max: 40 },
          Driver: { min: 28, max: 40 },
          Education: { min: 28, max: 40 },
          "Emergency and Protective Services": { min: 28, max: 40 },
          Engineering: { min: 32, max: 40 },
          "Farming, Agriculture and Forestry": { min: 26, max: 40 },
          "Finance Manager": { min: 33, max: 40 },
          "Financial Services": { min: 29, max: 40 },
          "Food Preparation and Service": { min: 27, max: 40 },
          "Freight and Distribution": { min: 27, max: 40 },
          "Front Line Supervision": { min: 30, max: 40 },
          "Grounds and Cleaning": { min: 27, max: 40 },
          "HR Manager": { min: 30, max: 40 },
          "Human Resources": { min: 29, max: 40 },
          "IT and Computing Systems": { min: 30, max: 40 },
          "IT Manager": { min: 31, max: 40 },
          "IT Support": { min: 31, max: 40 },
          "Journalism and Communications": { min: 31, max: 40 },
          Legal: { min: 32, max: 40 },
          "Machinist / Manufacturing Technician": { min: 28, max: 40 },
          Management: { min: 30, max: 40 },
          "Marketing and Product": { min: 30, max: 40 },
          "Media Production": { min: 28, max: 40 },
          "Medical Assistance": { min: 29, max: 40 },
          "Medicine and Healthcare": { min: 30, max: 40 },
          "Mining, Oil, and Gas Worker": { min: 26, max: 40 },
          Nursing: { min: 31, max: 40 },
          "Office and Administrative Support": { min: 30, max: 40 },
          "Paralegal and Legal Support": { min: 31, max: 40 },
          "Personal Care and Services": { min: 27, max: 40 },
          "Plant Operator": { min: 29, max: 40 },
          "Production Manager / Supervisor": { min: 29, max: 40 },
          "Production Worker": { min: 25, max: 40 },
          "Project Manager": { min: 30, max: 40 },
          "Retail Sales": { min: 28, max: 40 },
          "Sales / Account Executive": { min: 29, max: 40 },
          "Sales Manager": { min: 29, max: 40 },
          "Sales Representative": { min: 30, max: 40 },
          "Science and Research": { min: 32, max: 40 },
          "Service Technician": { min: 27, max: 40 },
          "Software Development": { min: 29, max: 40 },
          "Store Manager": { min: 29, max: 40 },
          "Trades and Construction": { min: 27, max: 40 },
        },
      },
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
      "By Traits Raw Score": {
        title: "Traits",
        defaultValue: null,
        values: {
          Math: {
            min: 0,
            max: 20,
          },
          Verbal: {
            min: 0,
            max: 20,
          },
        },
      },
    },
    {
      average: 30.9,
      median: 33.0,
      cutoff: 31.0,
    },
    {
      raw: { first: "By Raw Score", second: null },
      percentile: { first: "By Overall Percentile", second: null },
      math: { first: "By Traits Raw Score", second: "Verbal" },
      verbal: { first: "By Traits Raw Score", second: "Math" },
    },
  ],
  13: [
    {
      testAbbrev: "CPI",
      testType: "Personality",
    },
    {
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          Agreeableness: {
            min: 0,
            max: 100,
          },
          Conscientiousness: {
            min: 0,
            max: 100,
          },
          Extroversion: {
            min: 0,
            max: 100,
          },
          Openness: {
            min: 0,
            max: 100,
          },
          "Stress Tolerance": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null, // No national norms data for CPI
    {
      AGREE: { first: "By Trait Percentile", second: "Agreeableness" },
      CONSC: {
        first: "By Trait Percentile",
        second: "Conscientiousness",
      },
      EXT: { first: "By Trait Percentile", second: "Extroversion" },
      OPEN: { first: "By Trait Percentile", second: "Openness" },
      STAB: { first: "By Trait Percentile", second: "Stress Tolerance" },
    },
  ],
  14: [
    {
      testAbbrev: "MRAB",
      testType: "Aptitude",
    },
    {
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          Attention: {
            min: 0,
            max: 100,
          },
          "Divided Attention": {
            min: 0,
            max: 100,
          },
          "Information Ordering": {
            min: 0,
            max: 100,
          },
          Logic: {
            min: 0,
            max: 100,
          },
          Memory: {
            min: 0,
            max: 100,
          },
          "Perceptual Reaction Time": {
            min: 0,
            max: 100,
          },
          Reasoning: {
            min: 0,
            max: 100,
          },
          "Selective Attention: Filtering": {
            min: 0,
            max: 100,
          },
          "Selective Attention: Vigilance": {
            min: 0,
            max: 100,
          },
          "Spatial Working Memory": {
            min: 0,
            max: 100,
          },
          "Verbal Working Memory": {
            min: 0,
            max: 100,
          },
          Visualization: {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null, // No national norms for MRAB
    {
      percentile: { first: "By Overall Percentile", second: null },
      ATT: { first: "By Trait Percentile", second: "Attention" },
      MEM: { first: "By Trait Percentile", second: "Memory" },
      REA: { first: "By Trait Percentile", second: "Reasoning" },
      DA: { first: "By Trait Percentile", second: "Divided Attention" },
      VIG: {
        first: "By Trait Percentile",
        second: "Selective Attention: Vigilance",
      },
      FIL: {
        first: "By Trait Percentile",
        second: "Selective Attention: Filtering",
      },
      VWM: {
        first: "By Trait Percentile",
        second: "Verbal Working Memory",
      },
      SWM: {
        first: "By Trait Percentile",
        second: "Spatial Working Memory",
      },
      VIS: { first: "By Trait Percentile", second: "Visualization" },
      LOG: { first: "By Trait Percentile", second: "Logic" },
      IO: {
        first: "By Trait Percentile",
        second: "Information Ordering",
      },
      PRT: {
        first: "By Trait Percentile",
        second: "Perceptual Reaction Time",
      },
    },
  ],
  15: [
    {
      testAbbrev: "CSAP",
      testType: "Personality",
    },
    ...SAP_CSAP_DROPDOWNS_INFO,
  ],
  16: [
    {
      testAbbrev: "WTMA",
      testType: "Aptitude",
    },
    {
      "By Raw Score": {
        title: "Score Range by Position",
        defaultValue: {
          min: 0,
          max: 60,
        },
        values: {
          Electrician: {
            min: 47,
            max: 56,
          },
          "Forklift Operator": {
            min: 44,
            max: 51,
          },
          "Manufacturing/Production": {
            min: 43,
            max: 52,
          },
          "Materials Handler": {
            min: 40,
            max: 52,
          },
          "Mechanic/Maintenance Tech": {
            min: 46,
            max: 54,
          },
          "Oil Services Worker": {
            min: 45,
            max: 53,
          },
          "Sales (Mechanical Equipment)": {
            min: 46,
            max: 54,
          },
          "Service Technician (Install & Repair)": {
            min: 46,
            max: 54,
          },
          Warehouse: {
            min: 42,
            max: 52,
          },
          "Utility Worker": {
            min: 46,
            max: 53,
          },
        },
      },
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
    },
    {
      average: 41.8,
      median: 42.0,
      cutoff: 40.0,
    },
    {
      raw: { first: "By Raw Score", second: null },
      percentile: { first: "By Overall Percentile", second: null },
    },
  ],
  17: [
    {
      testAbbrev: "TT",
      testType: "Skills",
    },
    {
      "By Adjusted WPM": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 160,
        },
        values: null,
      },
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
    },
    {
      average: 32.2,
      median: 32.0,
      cutoff: 30.0,
    },
    {
      raw: { first: "By Adjusted WPM", second: null },
      percentile: { first: "By Overall Percentile", second: null },
    },
  ],
  18: [
    {
      testAbbrev: "TKT",
      testType: "Skills",
    },
    {
      "By KPH": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 15000,
        },
        values: null,
      },
      // 'By Field Accuracy Rate': { 'N/A': [] }, // says NOTUSED
    },
    {
      average: 6668,
      median: 4986,
      cutoff: 4475,
    },
    {
      raw: { first: "By KPH", second: null },
    },
  ],
  19: getMicrosoftSkillsTestInfo(19),
  20: getMicrosoftSkillsTestInfo(20),
  21: getMicrosoftSkillsTestInfo(21),
  22: getMicrosoftSkillsTestInfo(22),
  23: [
    {
      testAbbrev: "CAST",
      testType: "Aptitude",
    },
    {
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          "Divided Attention": {
            min: 0,
            max: 100,
          },
          "Perceptual Reaction Time": {
            min: 0,
            max: 100,
          },
          "Selective Attention: Filtering": {
            min: 0,
            max: 100,
          },
          "Selective Attention: Vigilance": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null, // No national norms for CAST
    {
      percentile: { first: "By Overall Percentile", second: null },
      DA: { first: "By Trait Percentile", second: "Divided Attention" },
      VIG: {
        first: "By Trait Percentile",
        second: "Selective Attention: Vigilance",
      },
      FIL: {
        first: "By Trait Percentile",
        second: "Selective Attention: Filtering",
      },
      PRT: {
        first: "By Trait Percentile",
        second: "Perceptual Reaction Time",
      },
    },
  ],
  24: [
    {
      testAbbrev: "SalesAP",
      testType: "Personality",
    },
    ...SAP_CSAP_DROPDOWNS_INFO,
  ],
  29: [
    {
      testAbbrev: "EPP",
      testType: "Personality",
    },
    {
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          Achievement: {
            min: 0,
            max: 100,
          },
          Assertiveness: {
            min: 0,
            max: 100,
          },
          Competitiveness: {
            min: 0,
            max: 100,
          },
          Conscientiousness: {
            min: 0,
            max: 100,
          },
          Cooperativeness: {
            min: 0,
            max: 100,
          },
          Extroversion: {
            min: 0,
            max: 100,
          },
          Managerial: {
            min: 0,
            max: 100,
          },
          Motivation: {
            min: 0,
            max: 100,
          },
          Patience: {
            min: 0,
            max: 100,
          },
          "Self-Confidence": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null, // no national norms data for EPP
    {
      ACH: { first: "By Trait Percentile", second: "Achievement" },
      MOT: { first: "By Trait Percentile", second: "Motivation" },
      CMP: { first: "By Trait Percentile", second: "Competitiveness" },
      MGT: { first: "By Trait Percentile", second: "Managerial" },
      AST: { first: "By Trait Percentile", second: "Assertiveness" },
      EXT: { first: "By Trait Percentile", second: "Extroversion" },
      COP: { first: "By Trait Percentile", second: "Cooperativeness" },
      PAT: { first: "By Trait Percentile", second: "Patience" },
      SCN: { first: "By Trait Percentile", second: "Self-Confidence" },
      CON: { first: "By Trait Percentile", second: "Stress Tolerance" },
    },
  ],
  30: [
    {
      testAbbrev: "CLIK",
      testType: "Skills",
    },
    {
      "By Raw Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Proficiency (Highly Proficient, Proficient, Not Proficient)": {
        title: "N/A",
        defaultValue: {
          min: 1,
          max: 3,
        },
        values: null,
      },
    },
    {
      average: 15.5,
      median: 16.0,
      cutoff: 14.0,
    },
    {
      raw: { first: "By Raw Score", second: null },
      ranking: {
        first: "By Proficiency (Highly Proficient, Proficient, Not Proficient)",
        second: null,
      },
    },
  ],
  31: [
    {
      testAbbrev: "WPP",
      testType: "Personality",
    },
    {
      "By Recommendation": {
        title: "N/A",
        defaultValue: {
          min: 1,
          max: 3,
        },
        values: null,
      },
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          "Attitudes Towards Theft": {
            min: 0,
            max: 100,
          },
          Conscientiousness: {
            min: 0,
            max: 100,
          },
          "Integrity/Honesty": {
            min: 0,
            max: 100,
          },
          Perseverance: {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null, // no national norms data for WPP
    {
      raw: { first: "By Recommendation", second: null },
      CON: { first: "By Trait Percentile", second: "Conscientiousness" },
      PER: { first: "By Trait Percentile", second: "Perseverance" },
      HON: { first: "By Trait Percentile", second: "Integrity/Honesty" },
      THEFT: {
        first: "By Trait Percentile",
        second: "Attitudes Towards Theft",
      },
    },
  ],
  32: getMicrosoftSkillsTestInfo(32),
  33: getMicrosoftSkillsTestInfo(33),
  34: [
    {
      testAbbrev: "EPP",
      testType: "Personality",
    },
    {
      "By Job Family Match %": {
        title: "Job Family",
        defaultValue: null,
        values: {
          "Accounting and Finance": {
            min: 0,
            max: 100,
          },
          "Administrative and Clerical": {
            min: 0,
            max: 100,
          },
          "Analysis, Planning and Consulting": {
            min: 0,
            max: 100,
          },
          "Tellers and Clerical Finance": {
            min: 0,
            max: 100,
          },
          "Account Collection and Receivables": {
            min: 0,
            max: 100,
          },
          "Client and Customer Service": {
            min: 0,
            max: 100,
          },
          "Front Desk and Reception": {
            min: 0,
            max: 100,
          },
          "Management and Leadership": {
            min: 0,
            max: 100,
          },
          "Healthcare Practice and Support": {
            min: 0,
            max: 100,
          },
          "Production and Manufacturing": {
            min: 0,
            max: 100,
          },
          "Software Engineering and Development": {
            min: 0,
            max: 100,
          },
          "Sales and Business Development": {
            min: 0,
            max: 100,
          },
        },
      },
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          Achievement: {
            min: 0,
            max: 100,
          },
          Assertiveness: {
            min: 0,
            max: 100,
          },
          Competitiveness: {
            min: 0,
            max: 100,
          },
          Conscientiousness: {
            min: 0,
            max: 100,
          },
          Cooperativeness: {
            min: 0,
            max: 100,
          },
          Extroversion: {
            min: 0,
            max: 100,
          },
          Managerial: {
            min: 0,
            max: 100,
          },
          Motivation: {
            min: 0,
            max: 100,
          },
          Openness: {
            min: 0,
            max: 100,
          },
          Patience: {
            min: 0,
            max: 100,
          },
          "Self-Confidence": {
            min: 0,
            max: 100,
          },
          "Stress Tolerance": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null, // no national norms data for EPP
    {
      ACH: { first: "By Trait Percentile", second: "Achievement" },
      MOT: { first: "By Trait Percentile", second: "Motivation" },
      CMP: { first: "By Trait Percentile", second: "Competitiveness" },
      MGT: { first: "By Trait Percentile", second: "Managerial" },
      AST: { first: "By Trait Percentile", second: "Assertiveness" },
      EXT: { first: "By Trait Percentile", second: "Extroversion" },
      COP: { first: "By Trait Percentile", second: "Cooperativeness" },
      PAT: { first: "By Trait Percentile", second: "Patience" },
      SCN: { first: "By Trait Percentile", second: "Self-Confidence" },
      CON: { first: "By Trait Percentile", second: "Conscientiousness" },
      OPEN: { first: "By Trait Percentile", second: "Openness" },
      STAB: { first: "By Trait Percentile", second: "Stress Tolerance" },
      Manager: {
        first: "By Job Family Match %",
        second: "Management and Leadership",
      },
      AccountingFinance: {
        first: "By Job Family Match %",
        second: "Accounting and Finance",
      },
      Administrative_Assistant: {
        first: "By Job Family Match %",
        second: "Administrative and Clerical",
      },
      Analyst: {
        first: "By Job Family Match %",
        second: "Analysis, Planning and Consulting",
      },
      Bank_Teller: {
        first: "By Job Family Match %",
        second: "Tellers and Clerical Finance",
      },
      Collections: {
        first: "By Job Family Match %",
        second: "Account Collection and Receivables",
      },
      Customer_Service: {
        first: "By Job Family Match %",
        second: "Client and Customer Service",
      },
      Front_DeskReception: {
        first: "By Job Family Match %",
        second: "Front Desk and Reception",
      },
      Medical_Assistant: {
        first: "By Job Family Match %",
        second: "Healthcare Practice and Support",
      },
      ProductionManufacturing: {
        first: "By Job Family Match %",
        second: "Production and Manufacturing",
      },
      ProgrammerDeveloper: {
        first: "By Job Family Match %",
        second: "Software Engineering and Development",
      },
      Sales: {
        first: "By Job Family Match %",
        second: "Sales and Business Development",
      },
      percentile: {
        first: "By Job Family Match %",
        second: null,
      },
    },
  ],
  35: getMicrosoftSkillsTestInfo(35),
  36: getMicrosoftSkillsTestInfo(36),
  37: [
    {
      testAbbrev: "UCAT",
      testType: "Aptitude",
    },
    {
      "By Raw Score": {
        title: "Score Range by Position",
        defaultValue: {
          min: 0,
          max: 40,
        },
        values: {
          Accounting: { min: 16, max: 40 },
          Analyst: { min: 18, max: 40 },
          "Architecture and Drafting": { min: 16, max: 40 },
          "Art and Design": { min: 15, max: 40 },
          Aviation: { min: 16, max: 40 },
          "Business Operations Specialist": { min: 16, max: 40 },
          Cashier: { min: 12, max: 40 },
          Collections: { min: 15, max: 40 },
          "Counselling and Social Work": { min: 16, max: 40 },
          "Customer Service Representative": { min: 13, max: 40 },
          "Data Analytics and Statistics": { min: 20, max: 40 },
          Dispatcher: { min: 14, max: 40 },
          Driver: { min: 11, max: 40 },
          Education: { min: 16, max: 40 },
          "Emergency and Protective Services": { min: 15, max: 40 },
          Engineering: { min: 18, max: 40 },
          "Farming, Agriculture and Forestry": { min: 14, max: 40 },
          "Finance Manager": { min: 18, max: 40 },
          "Financial Services": { min: 16, max: 40 },
          "Food Preparation and Service": { min: 11, max: 40 },
          "Freight and Distribution": { min: 11, max: 40 },
          "Front Line Supervision": { min: 15, max: 40 },
          "Grounds and Cleaning": { min: 12, max: 40 },
          "HR Manager": { min: 17, max: 40 },
          "Human Resources": { min: 16, max: 40 },
          "IT and Computing Systems": { min: 17, max: 40 },
          "IT Manager": { min: 16, max: 40 },
          "IT Support": { min: 16, max: 40 },
          "Journalism and Communications": { min: 16, max: 40 },
          Legal: { min: 20, max: 40 },
          "Machinist / Manufacturing Technician": { min: 12, max: 40 },
          Management: { min: 16, max: 40 },
          "Marketing and Product": { min: 17, max: 40 },
          "Media Production": { min: 16, max: 40 },
          "Medical Assistance": { min: 15, max: 40 },
          "Medicine and Healthcare": { min: 18, max: 40 },
          "Mining, Oil, and Gas Worker": { min: 12, max: 40 },
          Nursing: { min: 17, max: 40 },
          "Office and Administrative Support": { min: 15, max: 40 },
          "Paralegal and Legal Support": { min: 15, max: 40 },
          "Personal Care and Services": { min: 13, max: 40 },
          "Plant Operator": { min: 14, max: 40 },
          "Production Manager / Supervisor": { min: 15, max: 40 },
          "Production Worker": { min: 10, max: 40 },
          "Project Manager": { min: 17, max: 40 },
          "Retail Sales": { min: 13, max: 40 },
          "Sales / Account Executive": { min: 15, max: 40 },
          "Sales Manager": { min: 16, max: 40 },
          "Sales Representative": { min: 13, max: 40 },
          "Science and Research": { min: 18, max: 40 },
          "Senior and Executive Leadership": { min: 18, max: 40 },
          "Service Technician": { min: 13, max: 40 },
          "Software Development": { min: 16, max: 40 },
          "Store Manager": { min: 14, max: 40 },
          "Trades and Construction": { min: 14, max: 40 },
        },
      },
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          "Attention to Detail": {
            min: 0,
            max: 100,
          },
          "Logic & Analysis": {
            min: 0,
            max: 100,
          },
          "Numerical Reasoning": {
            min: 0,
            max: 100,
          },
          "Spatial Reasoning": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    {
      average: 20.2,
      median: 19.0,
      cutoff: 18.0,
    },
    {
      raw: { first: "By Raw Score", second: null },
      percentile: { first: "By Overall Percentile", second: null },
      logic: {
        first: "By Trait Percentile",
        second: "Logic & Analysis",
      },
      math: {
        first: "By Trait Percentile",
        second: "Numerical Reasoning",
      },
      detail: {
        first: "By Trait Percentile",
        second: "Attention to Detail",
      },
      spatial: {
        first: "By Trait Percentile",
        second: "Spatial Reasoning",
      },
    },
  ],
  38: getMicrosoftSkillsTestInfo(38),
  39: getMicrosoftSkillsTestInfo(39),
  40: getMicrosoftSkillsTestInfo(40),
  41: getMicrosoftSkillsTestInfo(41),
  42: [
    {
      testAbbrev: "GAME",
      testType: "Aptitude",
    },
    {
      "By Overall Percentile": {
        title: "Score Range by Position",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: {
          Accounting: { min: 64, max: 100 },
          Analyst: { min: 71, max: 100 },
          "Architecture and Drafting": { min: 62, max: 100 },
          "Art and Design": { min: 60, max: 100 },
          Aviation: { min: 63, max: 100 },
          "Business Operations Specialist": { min: 66, max: 100 },
          Cashier: { min: 40, max: 100 },
          Collections: { min: 54, max: 100 },
          "Counselling and Social Work": { min: 67, max: 100 },
          "Customer Service Representative": { min: 53, max: 100 },
          "Data Analytics and Statistics": { min: 75, max: 100 },
          Dispatcher: { min: 59, max: 100 },
          Driver: { min: 49, max: 100 },
          Education: { min: 55, max: 100 },
          "Emergency and Protective Services": { min: 43, max: 100 },
          Engineering: { min: 66, max: 100 },
          "Farming, Agriculture and Forestry": { min: 38, max: 100 },
          "Finance Manager": { min: 74, max: 100 },
          "Financial Services": { min: 69, max: 100 },
          "Food Preparation and Service": { min: 41, max: 100 },
          "Freight and Distribution": { min: 36, max: 100 },
          "Front Line Supervision": { min: 59, max: 100 },
          "Grounds and Cleaning": { min: 52, max: 100 },
          "HR Manager": { min: 67, max: 100 },
          "Human Resources": { min: 64, max: 100 },
          "IT and Computing Systems": { min: 66, max: 100 },
          "IT Manager": { min: 64, max: 100 },
          "IT Support": { min: 63, max: 100 },
          "Journalism and Communications": { min: 65, max: 100 },
          Legal: { min: 81, max: 100 },
          "Machinist / Manufacturing Technician": { min: 45, max: 100 },
          Management: { min: 62, max: 100 },
          "Marketing and Product": { min: 66, max: 100 },
          "Media Production": { min: 56, max: 100 },
          "Medical Assistance": { min: 56, max: 100 },
          "Medicine and Healthcare": { min: 60, max: 100 },
          "Mining, Oil, and Gas Worker": { min: 47, max: 100 },
          Nursing: { min: 64, max: 100 },
          "Office and Administrative Support": { min: 52, max: 100 },
          "Paralegal and Legal Support": { min: 49, max: 100 },
          "Personal Care and Services": { min: 43, max: 100 },
          "Plant Operator": { min: 53, max: 100 },
          "Production Manager / Supervisor": { min: 59, max: 100 },
          "Production Worker": { min: 34, max: 100 },
          "Project Manager": { min: 68, max: 100 },
          "Retail Sales": { min: 48, max: 100 },
          "Sales / Account Executive": { min: 60, max: 100 },
          "Sales Manager": { min: 65, max: 100 },
          "Sales Representative": { min: 51, max: 100 },
          "Science and Research": { min: 74, max: 100 },
          "Service Technician": { min: 49, max: 100 },
          "Software Development": { min: 63, max: 100 },
          "Store Manager": { min: 60, max: 100 },
          "Trades and Construction": { min: 54, max: 100 },
        },
      },
      "By Trait Percentile": {
        title: "Trait",
        defaultValue: null,
        values: {
          "Attention to Detail": {
            min: 0,
            max: 100,
          },
          "Math & Logic": {
            min: 0,
            max: 100,
          },
          "Verbal Ability": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null,
    {
      percentile: { first: "By Overall Percentile", second: null },
      verbal: { first: "By Trait Percentile", second: "Verbal Ability" },
      math: { first: "By Trait Percentile", second: "Math & Logic" },
      detail: {
        first: "By Trait Percentile",
        second: "Attention to Detail",
      },
    },
  ],
  43: [
    {
      testAbbrev: "CMRA",
      testType: "Aptitude",
    },
    {
      "By Raw Score": {
        title: "Score Range by Position",
        defaultValue: {
          min: 0,
          max: 30,
        },
        values: {
          Driver: { min: 14, max: 30 },
          Engineering: { min: 18, max: 30 },
          "Farming, Agriculture and Forestry": { min: 13, max: 30 },
          "Freight and Distribution": { min: 14, max: 30 },
          "Front Line Supervision": { min: 16, max: 30 },
          "Grounds and Cleaning": { min: 14, max: 30 },
          "Machinist / Manufacturing Technician": { min: 14, max: 30 },
          "Mining, Oil, and Gas Worker": { min: 15, max: 30 },
          "Plant Operator": { min: 17, max: 30 },
          "Production Manager / Supervisor": { min: 16, max: 30 },
          "Production Worker": { min: 14, max: 30 },
          "Retail Sales": { min: 14, max: 30 },
          "Sales Representative": { min: 15, max: 30 },
          "Service Technician": { min: 16, max: 30 },
          "Trades and Construction": { min: 16, max: 30 },
        },
      },
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
    },
    null,
    {
      raw: { first: "By Raw Score", second: null },
      percentile: { first: "By Overall Percentile", second: null },
    },
  ],
  44: [
    {
      testAbbrev: "Emotify",
      testType: "Emotional Intelligence",
    },
    {
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          "Perceiving Emotions": {
            min: 0,
            max: 100,
          },
          "Understanding Emotions": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null, // no national norms data for emotify
    {
      percentile: { first: "By Overall Percentile", second: null },
      perceivingPercentile: {
        first: "By Trait Percentile",
        second: "Perceiving Emotions",
      },
      understandPercentile: {
        first: "By Trait Percentile",
        second: "Understanding Emotions",
      },
    },
  ],
  45: [
    {
      testAbbrev: "Cognify",
      testType: "Aptitude",
    },
    {
      "By Overall Percentile": COGNIFY_UCOGNIFY_OVERALL_PERCENTILE_INFO,
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          "Problem Solving": {
            min: 0,
            max: 100,
          },
          "Numerical Reasoning": {
            min: 0,
            max: 100,
          },
          "Verbal Knowledge": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null,
    {
      percentile: { first: "By Overall Percentile", second: null },
      problemSolvingPercentile: {
        first: "By Trait Percentile",
        second: "Problem Solving",
      },
      math: {
        first: "By Trait Percentile",
        second: "Numerical Reasoning",
      },
      verbalKnowledgePercentile: {
        first: "By Trait Percentile",
        second: "Verbal Knowledge",
      },
    },
  ],
  46: [
    {
      testAbbrev: "WSP",
      testType: "Risk",
    },
    {
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          "Safety Control": {
            min: 0,
            max: 100,
          },
          "Risk Aversion": {
            min: 0,
            max: 100,
          },
          "Stress Management": {
            min: 0,
            max: 100,
          },
          "Drug Aversion": {
            min: 0,
            max: 100,
          },
          "Attitudes Towards Violence": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null,
    {
      percentile: { first: "By Overall Percentile", second: null },
      safety: {
        first: "By Trait Percentile",
        second: "Safety Control",
      },
      risk: {
        first: "By Trait Percentile",
        second: "Risk Aversion",
      },
      stress: {
        first: "By Trait Percentile",
        second: "Stress Management",
      },
      drug: {
        first: "By Trait Percentile",
        second: "Drug Aversion",
      },
      violence: {
        first: "By Trait Percentile",
        second: "Attitudes Towards Violence",
      },
    },
  ],
  48: [
    {
      testAbbrev: "Illustrait",
      testType: "Personality",
    },
    {
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
    },
    null,
    { percentile: { first: "By Overall Percentile", second: null } },
  ],
  49: [
    {
      testAbbrev: "CLIK",
      testType: "Skills",
    },
    {
      "By Raw Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 25,
        },
        values: null,
      },
      "By Proficiency (Highly Proficient, Proficient, Not Proficient)": {
        title: "N/A",
        defaultValue: {
          min: 1,
          max: 3,
        },
        values: null,
      },
    },
    {
      average: 19.5,
      median: 20.0,
      cutoff: 18.0,
    },
    {
      raw: { first: "By Raw Score", second: null },
      ranking: {
        first: "By Proficiency (Highly Proficient, Proficient, Not Proficient)",
        second: null,
      },
    },
  ],
  50: [
    {
      testAbbrev: "WAA",
      testType: "Personality",
    },
    {
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
    },
    null,
    { percentile: { first: "By Overall Percentile", second: null } },
  ],
  51: [
    {
      testAbbrev: "Emotify",
      testType: "Emotional Intelligence",
    },
    {
      "By Overall Percentile": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 100,
        },
        values: null,
      },
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          "Perceiving Emotions": {
            min: 0,
            max: 100,
          },
          "Understanding Emotions": {
            min: 0,
            max: 100,
          },
          "Managing Emotions": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null, // no national norms data for emotify
    {
      percentile: { first: "By Overall Percentile", second: null },
      perceivingPercentile: {
        first: "By Trait Percentile",
        second: "Perceiving Emotions",
      },
      understandPercentile: {
        first: "By Trait Percentile",
        second: "Understanding Emotions",
      },
      managingPercentile: {
        first: "By Trait Percentile",
        second: "Managing Emotions",
      },
    },
  ],
  52: [
    {
      testAbbrev: "UCognify",
      testType: "Aptitude",
    },
    {
      "By Overall Percentile": COGNIFY_UCOGNIFY_OVERALL_PERCENTILE_INFO,
      "By Trait Percentile": {
        title: "Traits",
        defaultValue: null,
        values: {
          "Problem Solving": {
            min: 0,
            max: 100,
          },
          "Numerical Reasoning": {
            min: 0,
            max: 100,
          },
        },
      },
    },
    null,
    {
      percentile: { first: "By Overall Percentile", second: null },
      problemSolvingPercentile: {
        first: "By Trait Percentile",
        second: "Problem Solving",
      },
      math: {
        first: "By Trait Percentile",
        second: "Numerical Reasoning",
      },
      verbalKnowledgePercentile: {
        first: "By Trait Percentile",
        second: "Verbal Knowledge",
      },
    },
  ],
  53: [
    {
      testAbbrev: "Excel365",
      testType: "Skills",
    },
    {
      "By Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)":
        {
          title: "N/A",
          defaultValue: {
            min: 1,
            max: 5,
          },
          values: null,
        },
    },
    null,
    {
      score: { first: "By Score", second: null },
      proficiency: {
        first:
          "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)",
        second: null,
      },
    },
  ],
  54: [
    {
      testAbbrev: "Word365",
      testType: "Skills",
    },
    {
      "By Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)":
        {
          title: "N/A",
          defaultValue: {
            min: 1,
            max: 5,
          },
          values: null,
        },
    },
    null,
    {
      score: { first: "By Score", second: null },
      proficiency: {
        first:
          "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)",
        second: null,
      },
    },
  ],
  55: [
    {
      testAbbrev: "PowerPoint365",
      testType: "Skills",
    },
    {
      "By Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)":
        {
          title: "N/A",
          defaultValue: {
            min: 1,
            max: 5,
          },
          values: null,
        },
    },
    null,
    {
      score: { first: "By Score", second: null },
      proficiency: {
        first:
          "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)",
        second: null,
      },
    },
  ],
  57: [
    {
      testAbbrev: "CLPT-EN",
      testType: "Skills",
    },
    {
      "By Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)":
        {
          title: "N/A",
          defaultValue: {
            min: 1,
            max: 5,
          },
          values: null,
        },
    },
    null,
    {
      score: { first: "By Score", second: null },
      proficiency: {
        first:
          "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)",
        second: null,
      },
    },
  ],
  "57_express": [
    {
      testAbbrev: "CLPTE-EN",
      testType: "Skills",
    },
    {
      "By Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)":
        {
          title: "N/A",
          defaultValue: {
            min: 1,
            max: 5,
          },
          values: null,
        },
    },
    null,
    {
      score: { first: "By Score", second: null },
      proficiency: {
        first:
          "By Proficiency (Beginner, Foundational, Intermediate, Skilled, Advanced)",
        second: null,
      },
    },
  ],
  59: [
    {
      testAbbrev: "CTRSE",
      testType: "Aptitude",
    },
    {
      "By Overall Percentile": CTRSE_OVERALL_PERCENTILE_INFO,
    },
    null,
    { percentile: { first: "By Overall Percentile", second: null } },
  ],
};

// Additional custom filter options which we only add in certain cases
export const EXTRA_CUSTOM_FILTER_OPTIONS_LIBRARY = {
  57: [
    null,
    {
      "By Reading Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Reading Proficiency": {
        title: "N/A",
        defaultValue: {
          min: 1,
          max: 5,
        },
        values: null,
      },
      "By Reading CEFR": {
        title: "N/A",
        defaultValue: {
          min: 1,
          max: 6,
        },
        values: null,
      },
      "By Listening Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Listening Proficiency": {
        title: "N/A",
        defaultValue: {
          min: 1,
          max: 5,
        },
        values: null,
      },
      "By Listening CEFR": {
        title: "N/A",
        defaultValue: {
          min: 1,
          max: 6,
        },
        values: null,
      },
      "By Writing Score": {
        title: "N/A",
        defaultValue: {
          min: 0,
          max: 20,
        },
        values: null,
      },
      "By Writing Proficiency": {
        title: "N/A",
        defaultValue: {
          min: 1,
          max: 5,
        },
        values: null,
      },
      "By Writing CEFR": {
        title: "N/A",
        defaultValue: {
          min: 1,
          max: 6,
        },
        values: null,
      },
    },
    null,
    {
      readingScore: { first: "By Reading Score", second: null },
      readingProficiency: {
        first: "By Reading Proficiency",
        second: null,
      },
      readingCEFR: { first: "By Reading CEFR", second: null },
      listeningScore: { first: "By Listening Score", second: null },
      listeningProficiency: {
        first: "By Listening Proficiency",
        second: null,
      },
      listeningCEFR: { first: "By Listening CEFR", second: null },
      writingScore: { first: "By Writing Score", second: null },
      writingProficiency: {
        first: "By Writing Proficiency",
        second: null,
      },
      writingCEFR: { first: "By Writing CEFR", second: null },
    },
  ],
};

export const EVALUATION_TOOLS_LIBRARY = {
  assessment: {
    key: "addAssessment",
    label: "Assessments",
    jobCreationIntroduction: `Evaluate your candidates with scientific, validated assessments that give you a fair, objective, accurate picture of each candidate and their potential job performance.`,
    jobPageMerchMessage: "", // not used
    icon: assessmentIcon,
    labelClassName: "",
    resultsTabDescription: "", // not used
    jobSettingsIntroduction: "", // not used
    talentSignalToggleField: "talentSignalAssessmentsOn",
    isStructuredInterview: false,
    pluralLabel: "Assessments",
  },
  videoInterview: {
    key: "addVideoInterview",
    label: "Video Interview",
    jobCreationIntroduction: `Save 75% of your time, and minimize bias with pre-recorded video interviews. Shortlist in seconds with Interview Intelligence: the first AI-powered, expert-level interview scoring.`,
    jobPageMerchMessage:
      "Save 75% of your time, and minimize bias with pre-recorded video interviews. Shortlist in seconds with Interview Intelligence: the first AI-powered, expert-level interview scoring.",
    icon: videoIcon,
    labelClassName: "SI-badge",
    resultsTabDescription:
      "Video Interviews enable you to evaluate candidates across job-relevant skills and competencies objectively and fairly. Structured interviews are 2x more predictive of performance than unstructured interviews, and can reduce bias and enable more consistent candidate comparisons.",
    jobSettingsIntroduction:
      "Save 75% of your time, and minimize bias with pre-recorded video interviews. Shortlist in seconds with Interview Intelligence: the first AI-powered, expert-level interview scoring.",
    talentSignalToggleField: "talentSignalVideoInterviewsOn",
    isStructuredInterview: true,
    pluralLabel: "Video Interviews",
    templateCreationIntroduction: `Evaluate candidates across job-relevant competencies with a structured video interview that is completed by candidates on their own time. Create a template that includes video responses, written responses and document uploads.`,
  },
  liveInterview: {
    key: "addLiveInterview",
    label: "Live Interview",
    jobCreationIntroduction: `Bring the power of structured interviews to all of your live candidate interactions, including phone screens, online or face-to-face interviews with a structured online evaluation.`,
    jobPageMerchMessage: `Create a structured interview for your in-person, phone, and panel interviews that ensures a consistent experience for all your candidates and is 2x more predictive of success.`, // used in jobSettings and jobCreation, shorter version than that in SI_MERCH_MESSAGE due to limited space
    icon: liveInterviewIcon,
    labelClassName: "SI-badge",
    resultsTabDescription:
      "Live structured interviews enable you to evaluate candidates across job-relevant skills and competencies objectively and fairly. They’re also 2x more predictive than unstructured interviews, and can reduce bias and enable more consistent candidate comparisons.",
    jobSettingsIntroduction:
      "Bring the power of structured interviews to all of your live candidate interactions, including phone screens, online or face-to-face interviews.",
    talentSignalToggleField: "talentSignalLiveInterviewsOn",
    isStructuredInterview: true,
    pluralLabel: "Live Interviews",
    templateCreationIntroduction: `Evaluate candidates across job-relevant competencies with a structured template that can be used during a live interview. Create a template with questions that include an evaluation guide and assign questions to interviewers.`,
  },
};

export const SI_MERCH_MESSAGE = {
  videoInterview:
    "Conduct structured video interviews that are 2x more predictive than unstructured interviews and designed to reduce bias. Evaluate your candidates across job-relevant competencies fairly and objectively.",
  liveInterview:
    "Bring the power of structured interviews to all your candidate interactions including live (online and face-to-face) interviews and phone screens. Structured interviews are 2x more predictive than unstructured interviews and enable you to evaluate candidates across job-relevant skills and competencies objectively and fairly.",
  structuredInterview:
    "Bring the power of structured interviews - which are 2x more predictive than unstructured interviews - to all of your candidate interactions. Assess job-critical competencies fairly, consistently and objectively.",
};

export const phoneCountryCodes = {
  US: "+1",
  AU: "+61",
  UK: "+44",
  IN: "+91",
};

// Allianz is the main company, which the rest are from the sms beta that used and sent an sms
export const smsOptinGrandfatheredCompanyIds = [
  133190, 11708, 50858, 225563, 212988, 149403, 186797, 224541, 185842, 110902,
  225990, 227429, 192571, 209342, 142206, 190312, 222088, 192242, 216174,
  177292, 208635, 180912, 204326, 218517, 204190, 200261, 224780, 228760,
  216986, 46037, 227504, 228013, 225176, 128967, 227676, 203333, 226589, 197962,
  214585, 15758, 227859, 223958, 220311, 223957, 213119, 194502, 214505, 2612,
  214470, 218970, 226567, 214257, 117439, 180263, 224559, 107892, 219056,
  181857, 200922, 164346, 161787, 227964, 212600, 222762, 227915, 195432,
  169263, 228830, 86272, 221741, 227253, 206833, 196211, 122494, 225701, 207373,
  198390, 223198, 226515, 224680, 221885, 226475, 181998, 227053, 222572,
  205283, 225500, 196818, 134254, 225184, 18905, 215763, 11186, 174820, 92767,
  214470,
];

export const DEFAULT_CLPT_SKILL_MODULES = ["reading", "listening", "writing"];

export const DYNAMIC_SCORE_REPORTS_PLATFORM_TESTS = [34, 57, 59];

export const vistaPartnerAccountIdArray = [
  15, 39, 40, 42, 44, 45, 46, 51, 52, 53, 54, 55, 56, 57, 58, 86, 87, 88, 89,
  90,
];

export const MULTIPLE_LANGUAGE_LEARN_MORE_URL = {
  na: "https://criteria.helpdocs.io/article/jab1q1pinj-test-languages-for-candidates",
  apac: "https://criteriacorp.helpdocs.io/article/aph8go94x5-candidate-assessment-languages",
};

export const NEW_LANDING_PAGE_HELP_DOC_URL = {
  na: "https://criteria.helpdocs.io/article/evkyac7vzl-create-a-new-landing-page",
  apac: "https://criteriacorp.helpdocs.io/article/4opraog7cy-create-a-new-landing-page",
};

export const INTERVIEW_INTELLIGENCE_LEARN_MORE_URL = {
  na: "https://criteria.helpdocs.io/article/ee9jlieka7-iiq",
  apac: "https://criteriacorp.helpdocs.io/article/qjmson8xg9-iiq",
};
